import { render, staticRenderFns } from "./ObsequiosTrazabilidad.vue?vue&type=template&id=44e6f39c&scoped=true"
import script from "./ObsequiosTrazabilidad.vue?vue&type=script&lang=js"
export * from "./ObsequiosTrazabilidad.vue?vue&type=script&lang=js"
import style0 from "./ObsequiosTrazabilidad.vue?vue&type=style&index=0&id=44e6f39c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e6f39c",
  null
  
)

export default component.exports